var router = require('pjax').Router;
var categoryIndex = require('./index.js');
var form = require('./form.js');

router.get('category/:any', form);
router.get('category', categoryIndex);
